// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import ModalPresentationPropsDefault from "@insite/mobius/Modal/presentationProps";
import { getProp } from "@insite/mobius/utilities";
import Close from "@sc/XDL/Icons/Close";
import { xBaseTheme } from "@sc/XDL/types";
import { color, xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

export default {
    sizeVariants: {
        small: 430,
        medium: 800,
        large: 1110,
    },
    defaultProps: {
        ...ModalPresentationPropsDefault,
        mergeCss: true,
        cssOverrides: {
            headlineTypography: css`
                margin-bottom: 0;
                letter-spacing: 0;
                word-break: break-word;
            `,
            modalTitle: css`
                position: relative;
                padding: 17px 17px 8px;
                border-bottom: 0;
                &:after {
                    content: "";
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    width: calc(100% - 32px);
                    height: 1px;
                    background-color: ${color("common.border")};
                    margin: 0 auto;
                }
            `,
            modalContent: css`
                &&& {
                    padding: 16px 17px 17px;
                }
            `,
            modalBody: css`
                border-radius: 4px;
                background-color: ${color("common.white")};
                box-shadow: 0 0 8px 0 ${color("common.ui7", 0.5)};
                ${xScreen("lt", "md")} {
                    max-width: 90%;
                    height: auto;
                    max-height: calc(100% - 30px);
                    margin: 15px;
                }
            `,
        },
        headlineTypographyProps: {
            size: 18,
            weight: "bold",
            lineHeight: "24px",
            forwardAs: "p",
        },
        closeButtonProps: {
            mergeCss: true,
            shape: "pill",
            buttonType: "solid",
            color: "common.background",
            css: css`
                width: 13px;
                height: 21px;
                padding: 0;
                min-height: initial;
                border: 0;

                & > ${IconWrapper} {
                    top: 0;
                }
                &&&:hover,
                &&&:focus {
                    background: transparent;
                }
                &&:hover > ${IconWrapper}, &:focus > ${IconWrapper} {
                    color: ${color("common.ui8")};
                }
            `,
        },
        closeButtonIconProps: {
            mergeCss: true,
            src: Close,
            size: 21,
            color: "text.link",
            css: css`
                &&& {
                    color: ${color("text.link")};
                }
                transition: all ${getProp("theme.transition.duration.regular")}ms ease-in-out;
                &,
                svg {
                    width: 13px;
                }
            `,
        },
    },
} as xBaseTheme["modal"];
